import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunk to fetch all clubs
export const fetchAllClubs = createAsyncThunk(
    'clubs/fetchAllClubs',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get('api/v1/get_all_clubs');
            return response.data.clubs || [];
        } catch (err) {
            console.error('Error fetching clubs:', err);
            return rejectWithValue(err.response?.data || 'Unknown error');
        }
    }
);

const clubsSlice = createSlice({
    name: 'clubs',
    initialState: {
        allClubs: [],
        loading: false,
        error: null,
    },
    reducers: {
        setAllClubs(state, action) {
            state.allClubs = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllClubs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllClubs.fulfilled, (state, action) => {
                state.loading = false;
                state.allClubs = action.payload;
            })
            .addCase(fetchAllClubs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setAllClubs } = clubsSlice.actions;
export default clubsSlice.reducer;
